<template>
  <el-container>
    <el-main>
      <el-form label-width="160px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="平台收取手续费比例">
              <el-input v-model="formData.charge_ratio">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="save">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'CommissionSetting',
  data () {
    return {
      formData: {
        charge_ratio: 1
      },
      records: []
    }
  },
  methods: {
    save () {
      console.log(this.formData)
    }
  }
}
</script>